import { render, staticRenderFns } from "./UpdatableTeam.vue?vue&type=template&id=4f7ccd57&scoped=true&"
import script from "./UpdatableTeam.vue?vue&type=script&lang=js&"
export * from "./UpdatableTeam.vue?vue&type=script&lang=js&"
import style0 from "./UpdatableTeam.vue?vue&type=style&index=0&id=4f7ccd57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7ccd57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VIcon,VMenu})
